<template>
  <div class="search-title">
    <h1 class="mobile-top-icon">
      <template v-if="selectedCategory.code!=='machines'">
        <button class="title-icon" @click="$store.commit('searchMachines/reset')"><i class="fa fa-arrow-left "></i>
        </button>
        {{ selectedCategory.label }}
      </template>
    </h1>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ResultsTitleMobile",
  computed: {
    ...mapState({
      selectedCategory: state => state.searchMachines.category
    }),
  }
}
</script>

<style lang="scss" scoped>
.search-title {
  justify-content: left;

  h1 {
    font-weight: bold
  }

  .title-icon {
    margin-right: 10px
  }

}
</style>